import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { MenuGroupGetAllService } from '../../services';

export const fetchMenuGroupGetAll = createAsyncThunk(
    'menuGroupGetAll/fetchMenuGroupGetAll',
    async () => {
        var data = localStorage.getItem('Menus')
        if (data) {
            return JSON.parse(data)
        }
        const response = await MenuGroupGetAllService()
        localStorage.setItem('Menus', JSON.stringify(response.result))
        return response.result
    }
);

const menuGroupGetAllSlice = createSlice({
    name: 'menuGroupGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenuGroupGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMenuGroupGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchMenuGroupGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default menuGroupGetAllSlice.reducer;
